export enum Breakpoint {
  xs = 'xs',
  sm = 'sm',
  ipad = 'ipad',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  xxl = 'xxl',
  xxxl = 'xxxl',
}

export const PixelsPerBreakpoint: Record<Breakpoint, number> = {
  [Breakpoint.xs]: 575, // mobile
  [Breakpoint.sm]: 767, // tablet
  [Breakpoint.ipad]: 769, // ipad
  [Breakpoint.md]: 991, // laptop
  [Breakpoint.lg]: 1200, // desktop,
  [Breakpoint.xl]: 1600, // desktop,
  [Breakpoint.xxl]: 1920, // desktop,
  [Breakpoint.xxxl]: 2560, // desktop,
};
